export interface PaymentMethodType {
  paymentMethodTypeId: number;
  paymentMethodTypeName: string;
}

export const emptyPaymentMethodType: PaymentMethodType = {
  paymentMethodTypeId: 0,
  paymentMethodTypeName: ''
}